<template>
	<div></div>
</template>

<script>
export default {
	name: "Logout",
	data: () => ({

	}),
	created(){
		this.$store.dispatch('logoutAdmin');
		this.$router.push('/login')
	}
};
</script>

<style>
</style>